function getCart() { 
  setTimeout(function() {
  var cartData = '';
  var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
     .then(response => response.json())
     .then(data => { 
       cartData = data;
       var giftInCart = false;
       for (let i = 0; i < data.items.length; i++) {
         let item_title = data.items[i].product_title;
         console.log(item_title);
         if(item_title.includes("Kingpin Thongs")) {
           giftInCart = true;
         }
       }
       calculateProgress(data.total_price, 5000);
       console.log(data.total_price);
       
     });
     console.log('click click');
  }, 500);
}
getCart(); 
  
function calculateProgress(currentVal, targetVal) {
  var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
  var progressNum = document.querySelectorAll('.cart-shipping__num');
  var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
  var successMsg = document.querySelectorAll('.cart-shipping__success');
  var result = Math.round(100 * currentVal / targetVal);
  var freeGiftContainer = document.getElementById('upsell');
  var cartContainer = document.getElementById('cart__content');
  
  var giftResult = Math.round(100 * currentVal / 10000);
  
  progressBar.forEach(function(el){
    el.setAttribute('style', "width: ".concat(result, "%"));
  })
  
  var newProgressNum = (targetVal - currentVal) / 100;
  if(newProgressNum <= 0){
      successMsg.forEach(function(el){
        el.setAttribute('style', 'display: block;');
      });
      progressOuter.forEach(function(el){
        el.setAttribute('style', 'display: none;');
      });
      progressNum.forEach(function(el){
        el.textContent = newProgressNum;
      });
  } else {
      successMsg.forEach(function(el){
        el.setAttribute('style', 'display: none;');
      });
      progressOuter.forEach(function(el){
        el.setAttribute('style', 'display: block;');
      });
      progressNum.forEach(function(el){
        el.textContent = newProgressNum;
      });
  }
  console.log(currentVal);
};

const container = document.querySelector('.go-cart-drawer__content');
  // Click handler for entire DIV container
container.addEventListener('click', function (e) {
    // But only alert for elements that have an alert-button class
  if (e.target.classList.contains('go-cart-item__quantity-button')) {
     getCart();
  }
  else if (e.target.classList.contains('go-cart-item__remove')) {
     setTimeout(function() {
     getCart();
    }, 500);
  }
});

var freeGiftContainer = document.getElementById('upsell');
freeGiftContainer.addEventListener('click', function (e) {
  if (e.target.classList.contains('add-to-cart-collection')) {
     getCart();
  }
});


var cart_buttons = document.getElementsByClassName("go-cart--shipping"); 
Array.from(cart_buttons).forEach(function(element) {
   element.addEventListener('click', getCart);
});   

